import { makeStyles } from 'tss-react/mui';
import { MOBILE_ORDER_PRODUCT_EXTRA_ROOT_PADDING } from '../../../../../../../orders/styles/useOrderProductItemStyles';
import { COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH } from '../../../../CombinationLine/consts/combinationLine.consts';

export const useKitDetailsCombinationStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    columnGap: '16px',
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: `0 ${MOBILE_ORDER_PRODUCT_EXTRA_ROOT_PADDING}px`,
      rowGap: '12px',
    },
  },
  infoSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '6px',
    [theme.breakpoints.up('sm')]: {
      width: COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH,
      maxWidth: COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH,
      minWidth: COMBINATION_WITH_IMAGE_INFO_SECTION_WIDTH,
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      paddingBottom: '16px',
    },
  },
  pricesAndActionsButtonContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'right',
    alignItems: 'center',
    columnGap: '16px',
  },
}));
